import { polygon, polygonMumbai } from 'viem/chains'
import { configureChains, createConfig } from 'wagmi'
import { InjectedConnector } from 'wagmi/connectors/injected'
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect'
import { alchemyProvider } from 'wagmi/providers/alchemy'
import { publicProvider } from 'wagmi/providers/public'
import constants from './constants'

// polygonMumbai.rpcUrls.public.http = 'https://rpc-mumbai.maticvigil.com'
polygonMumbai.rpcUrls.public.http[0] = 'https://rpc-mumbai.maticvigil.com'

const { chains, publicClient, webSocketPublicClient } = configureChains(
  constants.CHAIN === 137 ? [polygon] : [polygonMumbai],
  [alchemyProvider({ apiKey: constants.ALCHEMY_KEY }), publicProvider()]
)

// Set up wagmi config
const config = createConfig({
  autoConnect: true,
  connectors: [
    new InjectedConnector({
      chains,
      options: {
        name: 'Metamask',
        shimDisconnect: true
      }
    }),
    new WalletConnectConnector({
      chains,
      options: {
        projectId: constants.WALLET_CONNECT_PROJECT_ID,
        metadata: {
          name: 'Metropolis',
          description: 'Powered by Metropolis World',
          url: 'https://metropolisx.io',
          icons: ['https://metropolisx.io/apple-touch-icon.png']
        }
      }
    })
  ],
  publicClient,
  webSocketPublicClient
})

// Export
export default config
